import { useContext, useState } from "react";
import { ReactComponent as CalendarIcon } from "./../../../../../asset/icons/cal.svg";
import { ReactComponent as UserIcon } from "./../../../../../asset/icons/userIcon.svg";
import { del } from "../../../../../controlers/global/ConfigRequest";
import { DELETE_GROUP_CLUB } from "../../../../../helperData/ApiAddress";
import { ToastContext } from "../../../../../component/global/ToastContext";
import { Dropdown } from "react-bootstrap";
import moment from "moment-jalaali";
import { useTranslation } from "react-i18next";

export default function AllGroups({
    data,
    handleEditGroup,
    setEditMode,
    setActiveTab,
    setRefresh,
}) {
    const [check, setCheck] = useState(true);
    const { t } = useTranslation();
    const HandleCheckBox = () => {};

    const show = useContext(ToastContext);

    const deleteGroup = () => {
        del(DELETE_GROUP_CLUB.replace("{id}/", data.id)).then(() => {
            show(
                t(
                    "Src.Pages.CustomerClub.Components.UserManagment.NewUserModal.AllGroups.DeleteGroup.Success"
                ),
                "success"
            );
            setRefresh((prevState) => !prevState);
        });
    };

    const editGroup = () => {
        handleEditGroup(data.id, data.name);
        setEditMode(true);
        setActiveTab("1");
    };

    return (
        <div className="table-row">
            <div>
                <div
                    className={check ? "selected" : ""}
                    onClick={HandleCheckBox}
                >
                    <div></div>
                </div>
            </div>
            <div>
                <div></div>
                <div>
                    <div>{t("Organizational.CustomerClub.Level.Group")}</div>
                    <div>{data.name}</div>
                </div>
            </div>
            <div>
                <UserIcon />
                {data.members_count}
            </div>
            <div>
                <CalendarIcon />
                {moment(data.apdate_at).format("jYYYY/jMM/jDD")}
            </div>
            <div>
                <Dropdown>
                    <Dropdown.Toggle
                        variant="Secondary"
                        id="dropdown-basic"
                    ></Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item onClick={editGroup} href="#/action-1">
                            {t("Organizational.CustomerClub.Groups.Edit")}
                        </Dropdown.Item>
                        <Dropdown.Item onClick={deleteGroup} href="#/action-2">
                            {t("Organizational.CustomerClub.Groups.Remove")}
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    );
}
